import styled from '@emotion/styled';

import { times } from 'lodash';

import COLOR from '../../../../shared/constant/colorset';

const SkeletonStyle = styled.div`
  background-color: ${COLOR.kurlyGray200};
`;

const RecipeItems = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 12px;
`;

const RecipeItem = styled.div`
  width: 335px;
  position: relative;
`;

const RecipeImage = styled(SkeletonStyle)`
  height: 225px;
`;

const RecipeContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 10px;
  width: 100%;
`;

const RecipeTitle = styled(SkeletonStyle)`
  width: 150px;
  height: 20px;
`;

interface Props {
  itemCount: number;
}

export default function RecipeListSkeleton({ itemCount }: Props) {
  return (
    <RecipeItems>
      {times(itemCount, (num) => (
        <RecipeItem key={num}>
          <RecipeImage/>
          <RecipeContent>
            <RecipeTitle/>
          </RecipeContent>
        </RecipeItem>
      ))}
    </RecipeItems>
  );
}
